import { render, staticRenderFns } from "./Internet.vue?vue&type=template&id=72710ac8&scoped=true&"
import script from "./Internet.vue?vue&type=script&lang=js&"
export * from "./Internet.vue?vue&type=script&lang=js&"
import style0 from "./Internet.vue?vue&type=style&index=0&id=72710ac8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72710ac8",
  null
  
)

export default component.exports